import { generateFindingData } from "@handlers";

import { IssueType } from "@protos/issues/v1/issues";

export const findingsData = generateFindingData(10, IssueType.SAST);
